var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonDetailEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 36,
    viewBox: "0 0 111 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111 0.473145H0V35.9568H111V0.473145Z",
    fill: "#6A43B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.579 34.9415L106.656 32.8623L106.733 3.51565L109.579 1.48828V34.9415Z",
    fill: "#BF8FB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.656 32.8626L109.579 34.9418H1.4248L4.79272 32.5425L106.656 32.8626Z",
    fill: "#BF8FB5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4248 1.48828L4.34338 3.56748L4.27063 32.9141L1.4248 34.9415V1.48828Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34338 3.56748L1.4248 1.48828H109.579L106.211 3.88759L4.34338 3.56748Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.154 2.50073H2.8457V33.9296H108.154V2.50073Z",
    fill: "#FFDAF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.632 12.4551H35.126V13.3091H35.98V14.1771H36.848V22.1151H35.98V22.9831H35.126V23.8651H30.632V12.4551ZM34.972 22.8291V21.9751H35.84V14.3311H34.972V13.4631H31.668V22.8291H34.972ZM38.052 12.4551H44.268V13.4631H39.088V17.6351H43.4V18.6571H39.088V22.8291H44.268V23.8651H38.052V12.4551ZM48.076 14.3311H45.472V13.3091H51.688V14.3311H49.098V23.8651H48.076V14.3311ZM52.892 21.1071H53.774V17.6351H54.642V15.0451H55.496V12.4551H56.518V15.0451H57.386V17.6351H58.24V21.1071H59.108V23.8651H58.1V21.2471H53.928V23.8651H52.892V21.1071ZM57.232 20.2391V17.7891H56.364V15.1991H55.65V17.7891H54.782V20.2391H57.232ZM62.902 12.4551H63.924V23.8651H62.902V12.4551ZM67.732 12.4551H68.768V22.8291H73.948V23.8651H67.732V12.4551ZM76.034 22.1151H75.152V20.2391H76.188V21.9751H77.042V22.8291H79.492V21.9751H80.36V19.5251H79.492V18.6571H76.902V17.7891H76.034V16.9211H75.152V14.1771H76.034V13.3091H76.902V12.4551H79.646V13.3091H80.5V14.1771H81.368V16.0671H80.36V14.3311H79.492V13.4631H77.042V14.3311H76.188V16.7811H77.042V17.6351H79.646V18.5031H80.5V19.3711H81.368V22.1151H80.5V22.9831H79.646V23.8651H76.902V22.9831H76.034V22.1151Z",
    fill: "#34009D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDetailEn);
export default __webpack_public_path__ + "static/media/button-detail-en.f78cec5328e3eaa0af099af0c2ec7073.svg";
export { ForwardRef as ReactComponent };